import { useGlobalStore } from './use-store';

/**
 * `useZoom` watches and returns the zoom amount
 */
export function useZoom(): number {
  return useGlobalStore(({ zoom }) => zoom, []);
}
